module.exports = __webpack_public_path__ + "img/etf.b4200716.svg";